import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { fundingEnquiriesList } from './types';

import { requestFundingEnquiriesListSuccess, requestFundingEnquiriesListFailure } from './reducer';

const logger = new Logger('Saga:FundingEnquiriesList');

export function* requestFundingReportsListSaga() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.platform.get_enquiries'),
    );

    yield put(requestFundingEnquiriesListSuccess(response.data.data));
  } catch (error) {
    logger.error('Failed to request funding enquiry with the following error', error);
    yield put(requestFundingEnquiriesListFailure(error));
  }
}

export default function* fundingReportListSaga() {
  return yield all([takeLatest(fundingEnquiriesList.request, requestFundingReportsListSaga)]);
}
